import { createGroup } from './states';

export const services = {
  createGroup: createGroup,
};
